import React from 'react'
import { Contract } from '../../../../types/contract'
import { paymentMethodTypeStrings } from '../../../../utils/strings/DonationStrings'
import { translations } from '../../../../utils/translations/translations-manager'
import { RecurrenceTranslations } from '@cents/translations-utils'
import { formatAmount } from '../../../../utils/strings/amount-format'

export function ContractPaymentInfoBanner({ contract, className }: { contract: Contract; className?: string }): JSX.Element {
  return (
    <div className={''.concat(className ? ` ${className}` : '')}>
      <div className={'flex flex-row gap-3 p-3 rounded-xl bg-cents-purple text-cents-white items-center justify-center text-xs'}>
        <div className="flex flex-col">
          <span className="font-bold">{translations.texts.amount.toString()}</span>
          <span className={''}>{formatAmount((contract.donationAmount ?? 0) / 100)}</span>
        </div>
        {contract.subscriptionRecurrence && (
          <div className="flex flex-col pl-3">
            <span className="font-bold">{translations.texts.recurrence.toString()}</span>
            <span className={''}>
              {RecurrenceTranslations.getRecurrenceString(translations, {
                interval: contract.subscriptionRecurrence,
                count: contract.subscriptionRecurrenceCount ?? 1,
              })}
            </span>
          </div>
        )}
        {contract.paymentMethodType && (
          <div className="flex flex-col pl-3">
            <span className="font-bold">{translations.texts.short_payment_method.toString()}</span>
            <span className={''}>{paymentMethodTypeStrings[contract.paymentMethodType]()}</span>
          </div>
        )}
        {contract.stripePaymentMethodLast4 && (
          <div className="flex flex-col pl-3">
            <span className="font-bold">{translations.texts.short_payment_method_last_four.toString()}</span>
            <span className={''}>{contract.stripePaymentMethodLast4}</span>
          </div>
        )}
      </div>
    </div>
  )
}
